/**
 * ns.wow Download Center
 * Facade class for public accessible core functionality.
 */

import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "file-saver";

class Plugin {


  init() {
    const dlcContainers = document.querySelectorAll('.js-nhsdlc-container');
    dlcContainers.forEach( ( element ) => {
      let inputs = element.querySelectorAll('.js-nhsdlc-input');
      let filesize = element.querySelector('.js-nhsdlc-size-total');
      let button = element.querySelector('.js-nhsdlc-download');
      inputs.forEach( ( element ) => {
        this.checkConfiguration(element);
        element.addEventListener("change", (event) => {
          // let element = event.target;
          this.validateSelection(inputs, filesize, button);
        });
      });
      button.addEventListener("click", (event) => {
        // let element = event.target;
        this.createZipArchive(inputs);
      });
    });
  }


  checkConfiguration(element) {
    if ( ! element.hasAttribute('data-url') ) {
      console.error('ns.wow Download Center: no "data-url" found:', element);
    }
    if ( ! element.hasAttribute('data-size') ) {
      console.error('ns.wow Download Center: no "data-size" found:', element);
    }
  }


  validateSelection(inputs, filesize, button) {
    let size = 0;
    inputs.forEach( (element) => {
      if (element.tagName.toLowerCase() === 'input' && element.getAttribute('type') === 'checkbox' && element.checked) {
        size = size + parseInt(element.getAttribute('data-size'));
      }
    });
    if (size === 0) {
      button.setAttribute('disabled', 'true');
    } else {
      button.removeAttribute('disabled');
    }
    let sizeFormatted = this.humanFilesize(size);
    filesize.textContent = sizeFormatted;
  }


  createZipArchive(inputs) {
    const zip = new JSZip();
    const urls = [];
    inputs.forEach( (element) => {
      if (element.tagName.toLowerCase() === 'input' && element.getAttribute('type') === 'checkbox' && element.checked) {
        urls.push(element.getAttribute('data-url'));
      }
    });
    if (urls.length === 0) {
      return;
    }
    const zipFilename = NSContext.plugins.dlc.folderName + '.zip';
    let count = 0;
    for (let i = 0; i < urls.length; i++) {
      const fileparts = urls[i].split('/');
      const filename = fileparts[fileparts.length - 1];
      JSZipUtils.getBinaryContent(urls[i], (err, data) => {
        if (err) {
          throw err;
        }
        zip.file(filename, this.urlToPromise(urls[i]), {binary: true});
        count++;
        if (count === urls.length) {
          zip.generateAsync({type: 'blob'}).then(function (content) {
            saveAs(content, zipFilename);
          });
        }
      });
    }
  }


  humanFilesize(bytes) {
    let size = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let factor = Math.floor((bytes.toString().length - 1) / 3);
    let newSize = Math.round(bytes / Math.pow(1024, factor));
    return newSize + ' ' + size[factor];
  }


  urlToPromise(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }


}

export default new Plugin();
